import { api } from "@/lib/axios";

interface invoiceProps {
  id: string;
  invoiceNum: number;
  unit: string;
  unitSize: string;
  poBox: string;
  customField: string;
  totalPrice: number;
  taxes: number;
  services: {
    serviceName?: string;
    price?: number;
    quantity?: number;
  }[];
  createdAt: Date;
  buildingName: string;
}

interface InvoicesResponse {
  invoices: invoiceProps[];
  totalPages: number;
  totalInvoices: number;
  page: number;
}

export async function getInvoices(
  page = 1,
  pageSize = 8,
  month?: number,
  year?: number,
  buildingName?: string,
) {
  const queryParams = new URLSearchParams();

  queryParams.append("page", page.toString());
  queryParams.append("pageSize", pageSize.toString());

  if (month !== undefined) {
    queryParams.append("month", month.toString());
  }
  if (year !== undefined) {
    queryParams.append("year", year.toString());
  }
  if (buildingName !== undefined) {
    queryParams.append("buildingName", buildingName);
  }

  const { data } = await api.get<InvoicesResponse>(
    `/invoices?${queryParams.toString()}`,
  );

  return data;
}
